import DetailDialog from '@/components/provincial_level/detail_dialog/detail_dialog';
import QrcodeDialog from '@/components/provincial_level/qrcode_dialog/qrcode_dialog';
import PaymentDialog from '@/components/payment_dialog/payment_dialog';
import HealthDialog from '@/components/health_dialog/health_dialog';
import OperatorDialog from '@/components/operator_dialog/operator_dialog';
import companySvg from '@/assets/images/provincial/company.svg';
import waterSvg from '@/assets/images/provincial/water.svg';
import {Toast} from "vant";

export default{
    name : 'edu_service',
    data () {
        return {
            // 是否显示弹出层
            isShowDialog: false,
            isShowOperator: false,
            isShowPayment: false,
            isShowHealth: false,
            // 弹出层标题
            dialogTitle: '',
            // 弹出层数组
            dialogList: [],
            list: [/*{
                menuName: '预约检车',
                menuType: 2,
                url: 'https://user.cs96111.com/ad/record/url/auth?data=10;27;1',
                icon: '#icon-cheliangbaoxian'
            },*/ {
                menuName: '运营商业务',
                menuType: 2,
                icon: '#icon-hulianwang',
                dialog: 'isShowOperator'
            },{
                menuName: '便民保险',
                menuType: 2,
                url: 'https://user.cs96111.com/ad/record/url/auth?data=10;28;1',
                icon: '#icon-zmjk'
            }, {
                menuName: '健康服务',
                menuType: 2,
                dialog: 'isShowHealth',
                icon: '#icon-jiankangguanli'
            }, {
                menuName: '用水账单',
                menuType: 1,
                img: waterSvg,
                subMenu: [
                    {menuName: '用水账单',desc: '用水账单查询',url: 'https://user.cs96111.com/ad/record/url/auth?data=9;60;1'},
                ],
            },{
                menuName: '搬家运货',
                menuType: 2,
                dialog: 'toast',
                icon: '#icon-banjiayunhuo'
            }/*,{
                menuName: '号码标记查询',
                menuType: 2,
                img: numberMarkSvg,
                url: ''
            }*/]
        }
    },
    methods: {
        closeDialog() {
		    this.isShowDialog = false;
        },
        closePayment() {
            this.isShowPayment = false;
        },
        closeOperator() {
            this.isShowOperator = false;
        },
        closeHealth() {
            this.isShowHealth = false;
        },
		menuClick(item) {
            if(item.menuType == 1) {
                this.isShowDialog = true;
                this.dialogTitle = item.menuName
                this.dialogList = item.subMenu
                return;
            } else if(item.menuType == 2) {
                if(item.url == undefined) {
                    if(item.dialog == 'toast') {
                        Toast('功能建设中，敬请期待');
                        return;
                    }
                    this[item.dialog] = true;
                    return
                }
                if(item.url.indexOf('auth') != -1 && window.localStorage.getItem("token") != undefined) {
                    window.location.href = (item.url+ '&token=' + window.localStorage.getItem("token"));
                    return;
                }
                window.location.href = item.url
            }
        }
    },
	components: {
        'DetailDialog': DetailDialog,
        'QrcodeDialog': QrcodeDialog,
        'OperatorDialog': OperatorDialog,
        'PaymentDialog': PaymentDialog,
        'HealthDialog': HealthDialog
	}
}


// WEBPACK FOOTER //
// ./src/components/provincial_level/human_service/js/human_service.js